export default __webpack_public_path__ + "static/media/collections-baner-3.116586ba.svg";